import Lockr from 'lockr'
import {WhiteList,LocalStorageWay} from './config'

const localEvent = function (item) {
    this.get = function () {
        return localStorage.getItem(item) ? JSON.parse(localStorage.getItem(item)) : '';
    },
    this.set = function (key,value) {
        if (WhiteList.indexOf(key) == -1 && LocalStorageWay.indexOf(key) != -1) {
            Lockr.set(key, value)
        }
        else if (WhiteList.indexOf(key) == -1) {
            window.sessionStorage.setItem(key, JSON.stringify({data: value}));
        }
    },
    this.clear = function (key) {
        if (WhiteList.indexOf(key) == -1 && LocalStorageWay.indexOf(key) != -1) {
            Lockr.remove(key)
        }
        else if (WhiteList.indexOf(key) == -1) {
            window.sessionStorage.removeItem(key);
        }
    }
}

export const func = new localEvent('func');

/**
 * Created by wangrun on 2017/11/28.
 */
